import { render, staticRenderFns } from "./VDateField.vue?vue&type=template&id=4b646b0e"
import script from "./VDateField.vue?vue&type=script&lang=js"
export * from "./VDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports